const getters = {
  token: state => state.user.token,
  loginUrl: state => state.user.loginUrl,
  userId: state => state.user.userId,
  avatar: state => state.user.avatar,
  nickname: state => state.user.nickname,
  intro: state => state.user.intro,
  webSite: state => state.user.webSite,
  loginType: state => state.user.loginType,
  email: state => state.user.email,
  articleLikeSet: state => state.user.articleLikeSet,
  commentLikeSet: state => state.user.commentLikeSet,
  searchFlag: state => state.app.searchFlag,
  loginFlag: state => state.app.loginFlag,
  registerFlag: state => state.app.registerFlag,
  forgetFlag: state => state.app.forgetFlag,
  emailFlag: state => state.app.emailFlag,
  drawer: state => state.app.drawer,
  themeDark: state => state.app.themeDark,
  articleCount: state => state.blog.articleCount,
  categoryCount: state => state.blog.categoryCount,
  tagCount: state => state.blog.tagCount,
  viewsCount: state => state.blog.viewsCount,
  pwdChrtype: state => state.blog.pwdChrtype,
  blogAvatar: state => state.blog.blogAvatar,
  blogAuthor: state => state.blog.blogAuthor,
  blogIntro: state => state.blog.blogIntro,
  notice: state => state.blog.notice
};
export default getters;
